import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import { useReagents, useUser } from "@services/servicesGenericsTables";
import React from "react";
import { useFormContext } from "react-hook-form";

const Acidification = () => {
  const form = useFormContext();
  const { reagentsList } = useReagents();
  const { userList } = useUser();
  const filterSamplingProcedureList = useFilterSamplingProcedure("ACIDI");

  return (
    <ResponsiveFormContainer columns={5} mt={1}>
      <MAutocomplete
        key={JSON.stringify(form.getValues("conditioning_analyst"))}
        name="conditioning_analyst"
        options={userList}
        label="Seleccione un analista"
        getOptionLabel={(option) => option.username || ""}
        validation={{ required: "El analista es requerido" }}
      />
      <MAutocomplete
        key={JSON.stringify(
          form.getValues("conditioning_processing_procedure")
        )}
        name="conditioning_processing_procedure"
        options={filterSamplingProcedureList}
        label="Procedimiento MLPMA"
        getOptionLabel={(option) => `${option.numop}` || ""}
        validation={{
          required:
            filterSamplingProcedureList.length > 0
              ? "El procedimiento MLPMA es requerido"
              : false,
        }}
      />

      <MAutocomplete
        key={JSON.stringify(form.getValues("conditioning_reagent"))}
        name="conditioning_reagent"
        options={reagentsList.filter(
          (reagent) =>
            reagent.end_date_use === null && reagent.start_date_use != null
        )}
        label="Seleccione un Reactivo"
        getOptionLabel={(option) =>
          `${option.name}${
            option.number_lot ? ` - ${option.number_lot}` : ""
          } ${option.reactive_number ? ` - ${option.reactive_number}` : ""}
          ${!option.number_lot && !option.reactive_number ? ` - Sin lote` : ""}`
        }
        validation={{ required: "El reactivo es requerido" }}
      />
      <MDatePicker
        name="conditioning_date_time"
        pickerType="datetime"
        label="Fecha y hora Inicio"
        validation={{ required: "La fecha y hora de inicio es requerida" }}
      />

      <MTextField
        key={JSON.stringify(form.getValues("sample_for_tritium"))}
        name="sample_for_tritium"
        placeholder="Muestra para tritio"
        label="Muestra para tritio"
        type="text"
        fullWidth
        disabled
      />
    </ResponsiveFormContainer>
  );
};

export default Acidification;
